import { render, staticRenderFns } from "./RequestDetail.vue?vue&type=template&id=4b7e2165&scoped=true&"
import script from "./RequestDetail.vue?vue&type=script&lang=js&"
export * from "./RequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./RequestDetail.vue?vue&type=style&index=0&id=4b7e2165&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e2165",
  null
  
)

export default component.exports